export const SOFTLINE_API_GEWICHTSPORTAL_FATTENER = '/v1/titz/fattener/entities/{{id}}';
export const SOFTLINE_API_GEWICHTSPORTAL = 'v1/titz/weight-report/entities';
export const SOFTLINE_API_GEWICHTSPORTAL_TEMPLATE = 'v1/titz/weight-report/template';
export const SOFTLINE_API_GEWICHTSPORTAL_STABLE = 'v1/titz/stables/entities';
